import {Accordion} from '@/components';

import type {ProcessorWebhookConfig} from './processors';

type Props = {processor: ProcessorWebhookConfig};

export default function WebhookPrimer({processor}: Props) {
  const {primer, label} = processor;
  return (
    <Accordion
      title={`How to use the ${label} webhook`}
      defaultOpen
      headerStyle="border-2 rounded-md border-blue-200 dark:border-dark-borderMid bg-blue-50 dark:bg-transparent py-2 px-3"
      headerContent="text-blue-700 dark:text-blue-300"
    >
      <div className="text-sm text-gray-700 dark:text-gray-200 p-4 border border-blue-100 dark:border-dark-borderMid rounded-md mt-2">
        <p className="mb-3">{primer.summary}</p>
        <div className="font-semibold mb-1">Fields you should customize</div>
        <ul className="list-disc pl-5 space-y-1 mb-3">
          {primer.fields.map((f) => (
            <li key={f.path}>
              <code className="font-mono text-xs bg-gray-100 dark:bg-dark-borderMid px-1 py-0.5 rounded">
                {f.path}
              </code>{' '}
              {f.description}
              {f.example && (
                <>
                  {' '}
                  <em>e.g.</em>{' '}
                  <code className="font-mono text-xs">{f.example}</code>
                </>
              )}
            </li>
          ))}
        </ul>
        {primer.notes && primer.notes.length > 0 && (
          <>
            <div className="font-semibold mb-1">Notes</div>
            <ul className="list-disc pl-5 space-y-1">
              {primer.notes.map((n, i) => (
                <li key={i}>{n}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    </Accordion>
  );
}
